export const RESULTS_CACHE_TABLE = "tournamentResultsCache";
export const RESULTS_CACHE_POLL_MS = 3000;
export const RESULTS_CACHE_UPDATE_TIMEOUT_MS = 45000;
export const RESULTS_CACHE_UPDATE_TIMEOUT_MESSAGE =
  "Places did not finish updating. Try again.";
export const RESULTS_REBUILD_QUEUE_STALE_MS = 5 * 60 * 1000;

export function isResultsRebuildQueueStale(
  firstRequestedAt,
  now = Date.now(),
  maxAgeMs = RESULTS_REBUILD_QUEUE_STALE_MS
) {
  const started = new Date(firstRequestedAt).getTime();
  if (!Number.isFinite(started)) {
    return false;
  }
  return now - started > maxAgeMs;
}

export function resultsCacheFingerprint(resultsVersion, includePayouts) {
  const version = Number(resultsVersion);
  if (!Number.isFinite(version)) {
    return null;
  }
  return `${version}:${includePayouts ? 1 : 0}`;
}

export function resultsCacheRequestKey(
  tournamentId,
  eventId,
  showPayouts,
  cacheOnly = false
) {
  return `${tournamentId}|${eventId || ""}|${showPayouts ? 1 : 0}|${
    cacheOnly ? "c" : "i"
  }`;
}

export function shouldInvokeProcessTournamentResults({
  cacheOnly,
  forceRefresh,
  isReadyHit,
}) {
  if (forceRefresh) {
    return true;
  }
  if (cacheOnly) {
    return false;
  }
  return !isReadyHit;
}

export function isReadyCacheHit(row, expectedFingerprint) {
  return Boolean(
    row &&
      row.status === "ready" &&
      expectedFingerprint &&
      row.inputFingerprint === expectedFingerprint &&
      row.payload &&
      row.payload.success
  );
}

export function getUsableCachePayload(row) {
  if (row?.payload?.success) {
    return row.payload;
  }
  return null;
}

export function isResultsCacheUpdating(
  row,
  expectedFingerprint,
  { treatMissAsUpdating = false } = {}
) {
  if (!row) {
    return Boolean(treatMissAsUpdating);
  }
  if (row.status === "error") {
    return false;
  }
  if (row.status === "stale" || row.status === "computing") {
    return true;
  }
  if (expectedFingerprint && row.inputFingerprint !== expectedFingerprint) {
    return true;
  }
  return false;
}

export function resolveResultsUpdateTimeout({
  isUpdating,
  updatingStartedAt,
  now,
  errorMessage,
}) {
  if (!isUpdating || updatingStartedAt == null) {
    return { timedOut: false, updateError: null };
  }
  if (now - updatingStartedAt < RESULTS_CACHE_UPDATE_TIMEOUT_MS) {
    return { timedOut: false, updateError: null };
  }
  return {
    timedOut: true,
    updateError: errorMessage || RESULTS_CACHE_UPDATE_TIMEOUT_MESSAGE,
  };
}

export function isResultsCacheDebugEnabled() {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return window.localStorage.getItem("btaResultsCacheDebug") === "1";
  } catch {
    return false;
  }
}

export function logResultsCacheDebug(message, details) {
  if (!isResultsCacheDebugEnabled()) {
    return;
  }
  console.info(`[results-cache] ${message}`, details || "");
}
